"use client";

import React, { useEffect, useRef } from "react";
import Box from "./Box";

const TrustBox = () => {
  const ref = useRef(null);

  useEffect(() => {
    const loadTrustpilot = () => {
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(ref.current, true);
      }
    };

    loadTrustpilot();
  }, []);

  return (
    <Box className="TrustBox">
      <div
        ref={ref}
        className="trustpilot-widget"
        data-locale="en-US"
        data-template-id="53aa8807dec7e10d38f59f32"
        data-businessunit-id="67e3d89a07f885f02f1f5b3a"
        data-style-height="82px"
        data-style-width="165px"
        data-theme="dark"
      >
        <a
          href="https://uk.trustpilot.com/review/reskinned.clothing"
          target="_blank"
          rel="noopener"
        >
          {" "}
          Trustpilot
        </a>
      </div>
    </Box>
  );
};

export default TrustBox;
